// Identity is trusted only after a successful authenticated network response.
let actor = null;
export const currentActor = () => actor;
export const signedOut = () => localStorage.getItem("vt_signed_out") === "true";
export function setSessionActor(user) {
    const next = user?.id ? `${user.id}:${user.family_id || "none"}` : null;
    if (actor === next) return;
    actor = next;
    if (next) {
        const keep = `vt_draft_v2_${next}_`;
        Object.keys(localStorage).filter(k => (k.startsWith('vt_draft_') && !k.startsWith(keep)) || k === 'vt_drafts_index').forEach(k => localStorage.removeItem(k));
        localStorage.setItem('vt_session_owner', next);
    }
    window.dispatchEvent(new CustomEvent("vt:session-changed", { detail: next }));
}
export const draftPrefix = () => actor ? `vt_draft_v2_${actor}_` : null;
export function removeLocalDrafts() {
    Object.keys(localStorage).filter(k => k.startsWith("vt_draft_") || k.startsWith("vt_draft_v2_") || k === "vt_drafts_index").forEach(k => localStorage.removeItem(k));
}